import { render, staticRenderFns } from "./CommonData.vue?vue&type=template&id=5795c98a&scoped=true"
import script from "./CommonData.vue?vue&type=script&lang=js"
export * from "./CommonData.vue?vue&type=script&lang=js"
import style0 from "./CommonData.vue?vue&type=style&index=0&id=5795c98a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795c98a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5795c98a')) {
      api.createRecord('5795c98a', component.options)
    } else {
      api.reload('5795c98a', component.options)
    }
    module.hot.accept("./CommonData.vue?vue&type=template&id=5795c98a&scoped=true", function () {
      api.rerender('5795c98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/teacher/CommonData.vue"
export default component.exports